import { render, staticRenderFns } from "./UploadFileSendMessage.vue?vue&type=template&id=4a88fa22&scoped=true&"
import script from "./UploadFileSendMessage.vue?vue&type=script&lang=js&"
export * from "./UploadFileSendMessage.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileSendMessage.vue?vue&type=style&index=0&id=4a88fa22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88fa22",
  null
  
)

export default component.exports